export default "__VITE_ASSET__e6e3fdc4__"